import React from 'react';
import ADHeader from './AD/ADHeader';
import MottoHeader from './Motto/MottoHeader';
import MottoHeaderV2 from './MottoV2/MottoHeaderV2';
import WNResearchHeader from './WellNowResearch/WNResearchHeader';
import { useTheme } from '../../../';

var Header = function Header(_ref) {
  var contentfulData = _ref.contentfulData;
  var brandName = contentfulData.branding;
  var theme = useTheme();
  console.log('Theme in Root level---', theme);

  switch (brandName) {
    case 'aspendental':
      return React.createElement(ADHeader, {
        branding: brandName,
        contentfulData: contentfulData
      });

    case 'motto':
      return React.createElement(MottoHeader, {
        contentfulData: contentfulData
      });

    case 'mottoV2':
      return React.createElement(MottoHeaderV2, {
        contentfulData: contentfulData
      });

    case 'wellnow':
      return React.createElement(WNResearchHeader, {
        contentfulData: contentfulData
      });

    default:
      throw new Error('Header is required, Please create a brand specified header component.');
  }
};

export default Header;